import React, { useState } from "react";
import { Flex, Text, useToast } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { PRIMARY_HEX } from "../../../theme/primary";
import "./creditCard.css";

export const CreditCard = ({
  bg,
  pageColor: pageColorProp,
  utilityType: utilityTypeProp,
  name,
  greeting,
  userProfile,
  meterNumber,
  latestPurchaseDate  ,
}) => {
  const fallbackPageColor = useSelector(
    (state) => state?.switchTab?.brandColor?.brandColor,
  );
  const pageColor = pageColorProp || fallbackPageColor;

  const fallbackUtilityType = useSelector(
    (state) => state?.switchTab?.currentDisplay?.utilityType,
  );
  const utilityType = utilityTypeProp || fallbackUtilityType;

  const computedBg =
    bg ||
    pageColor ||
    (utilityType === "water"
      ? "#06b6d4"
      : utilityType === "electricity"
        ? "#f59e0b"
        : utilityType === "gas"
          ? "#fb7185"
          : PRIMARY_HEX);

  const [copied, setCopied] = useState(false);
  const toast = useToast();

  const displayMeter = meterNumber || "45628469817693";

  const handleCopyMeter = () => {
    navigator.clipboard.writeText(displayMeter).then(() => {
      setCopied(true);
      toast({
        title: "Meter number copied",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top",
      });
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const greetingByTime = () => {
    const myDate = new Date();
    const currentHour = myDate.getHours();

    let msg;

    if (currentHour < 12) msg = "Good Morning";
    else if (currentHour >= 12 && currentHour <= 15) msg = "Good Afternoon";
    else if (currentHour >= 16 && currentHour <= 24) msg = "Good Evening";
    return msg;
  };
  return (
    <div
      className="credit-card-wrap box-info"
      style={{
        height: "200px",
        background: computedBg,
        backgroundSize: "cover",
      }}
    >
      <div className="mk-icon-world-map"></div>
      <div className="credit-card-inner">
        <header className="header">
          <div className="credit-logo">
            <Flex justifyContent="space-between">
              <Text className="text" fontSize={["22px", "24px", "26px"]}>
                {name || userProfile?.name}
              </Text>
            </Flex>
            <h2 style={{ color: "white", marginBottom: "20px" }}>
              {greeting || greetingByTime()}
            </h2>
          </div>
        </header>

        <footer className="footer">
          <div className="clearfix">
            <div className="pull-left">
              <div className="credit-card-date">
                <span className="title">Meter Number</span>
                <span
                  className="credit-font"
                  onClick={handleCopyMeter}
                  title="Click to copy"
                  style={{
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    opacity: copied ? 0.7 : 1,
                    transition: "opacity 0.2s",
                  }}
                >
                  {displayMeter}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ flexShrink: 0, opacity: 0.8 }}
                  >
                    {copied ? (
                      <polyline points="20 6 9 17 4 12" />
                    ) : (
                      <>
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                      </>
                    )}
                  </svg>
                </span>
              </div>
            </div>
            <div className="pull-left">
              <div className="credit-card-date">
                <span className="title">Date of Latest Purchase</span>
                <span className="credit-font">
                  {latestPurchaseDate || "23 January, 2021"}
                </span>
              </div>
            </div>
            <div className="pull-right">
              <div className="mk-icon-visa"></div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};
